import { CHARGE_SCENARIO_LABELS } from '../constants/chargeFilterSchema';
import { countBy, distinct, partyKey, sumCents } from './invoiceSummary';

const amountOf = (value: unknown): number | null => (value == null ? null : Number(value));

const natureLabel = (row: any): string =>
    (row?.chargeScenario ? CHARGE_SCENARIO_LABELS[row.chargeScenario] || row.chargeScenario : 'Sem natureza');

export const summarizeCharges = (rows: any[]) => ({
    operations: distinct(rows, r => r?.creditOperationId || r?.operationNumber || null,
        r => r?.operationNumber || r?.contractLabel || null),
    issuers: distinct(rows, r => partyKey(r?.issuer), r => r?.issuer?.name || null),
    payers: distinct(rows, r => partyKey(r?.titlePayer), r => r?.titlePayer?.name || null),
    natures: countBy(rows, natureLabel),
    amount: sumCents(rows.map(r => amountOf(r?.amount))),
    paidAmount: sumCents(rows.map(r => amountOf(r?.paidAmount))),
    remainingAmount: sumCents(rows.map(r => amountOf(r?.remainingAmount))),
});
